// import WithdrawHeader from 'components/Header/WithdrawHeader';
import React from 'react';
// import GameInformation from './GameInformation';
// import { BoxWidth, FlexTotalWidth, GameInformationMainBox } from './GameLoadingStyled';
// import GamePreloader from './GamePreloader';
import WebGLScreen from './WebGLScreen/WebGLScreen';

const GamePlayLoading: React.FC = () => {

    return (
        <>
            {/* <WithdrawHeader /> */}
            <WebGLScreen />
            {/* <GamePreloader /> */}
            {/* <GameInformationMainBox>

                <FlexTotalWidth>
                    <BoxWidth>
                        <GameInformation />
                    </BoxWidth>
                </FlexTotalWidth>

            </GameInformationMainBox> */}

        </>
    )
}

export default GamePlayLoading